import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'hk.employer.staging.seek.com',
    clientId: 'RN6DzdiBeuBovaqnIlOnDCOKg3Q2VveX',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://hk.jobsdb.com/en-hk/cms/employer/recruitment-tips-and-guides/',
    },
    siteName: siteNames.employer.seek.hk,
    zone: getZoneFromSite(siteNames.employer.seek.hk),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=hk_employer_staging_seek_com.js.map